(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reccomended-products"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (!recommendations) return;

        console.log('Recommendations:', recommendations);

        let products = recommendations?.children[0].children[1].children;

        let found = false;

        products = Array.from(products).filter((product, i) => {
          if (!found && i === 4) {
            return false;
          }
          if (product.children[1].children[0].innerHTML === 'Shipping Protection by Route') {
            found = true;
            return false;
          }
          return true;
        });

        recommendations.children[0].children[1].innerHTML = products.map((product) => product.outerHTML).join('');

        if (recommendations.innerHTML.trim().length === 0) {
          const sectionEl = document.getElementById('shopify-section-product-recommendations');
          if (sectionEl) sectionEl.remove();
        } else {
          const moreProducts = document.getElementById('more-collection-products');
          if (moreProducts) moreProducts.remove();
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  if (productRecommendationsSection) {
    const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });
    observer.observe(productRecommendationsSection);
  }

  } catch(e) { console.error(e); }
})();
})();
